import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { Home } from 'lucide-react';
import notFound404Illustration from '@/assets/illustrations/not-found-404.svg';

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-bg bg-paper-noise px-6">
      <div className="pointer-events-none absolute -right-24 -top-32 h-[24rem] w-[24rem] rounded-full bg-gold-gradient-soft blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-[-8rem] h-[20rem] w-[20rem] rounded-full bg-gold-gradient-soft blur-3xl" />

      <div className="relative w-full max-w-md text-center">
        <img src={notFound404Illustration} alt="" aria-hidden width={140} height={140} className="mx-auto mb-2 opacity-90 select-none pointer-events-none" />
        <div className="mt-2 inline-flex rounded-full border border-border bg-surface/70 px-3 py-1 backdrop-blur-sm">
          <span className="font-mono text-xs font-semibold text-text-muted">ERROR · 404</span>
        </div>
        <h1 className="mt-4 font-display text-[34px] font-bold leading-tight tracking-tight text-text-primary">
          We couldn't find that page.
        </h1>
        <p className="mt-3 text-[15px] text-text-secondary">
          The link may be broken, or the page may have moved. Let's get you back on track.
        </p>
        <Link to="/" className="mt-7 inline-block">
          <Button size="lg" iconLeft={<Home size={16} />}>Take me home</Button>
        </Link>
      </div>
    </div>
  );
}
